import type { AITTheme } from '@this/shared/ui/theme';

export function getStyles(theme: AITTheme) {
  return {
    pageLayout: {
      display: 'flex' as const,
      flexDirection: 'column' as const,
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box' as const
    } as const,
    pageTitle: {
      padding: '20px',
      margin: 0,
      fontSize: '18px',
      borderBottom: 'none'
    } as const,
    contentIn: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      padding: '0 20px 20px',
      boxSizing: 'border-box' as const
    } as const,
    section: {
      borderBottom: '1px solid #cccccc',
      paddingBottom: '28px',
      marginBottom: '28px'
    } as const,
    sectionLast: {
      borderBottom: 'none',
      paddingBottom: 0
    } as const,
    sectionTitle: {
      margin: '0 0 12px',
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: 1.5,
      color: theme.tokens.colors.text.primary
    } as const,
    sectionDescription: {
      margin: '0 0 16px',
      fontSize: '14px',
      lineHeight: 1.5,
      color: theme.tokens.colors.text.primary
    } as const,
    formActions: {
      display: 'flex' as const,
      justifyContent: 'flex-start' as const,
      marginTop: '16px'
    } as const,
    submitButton: {
      minWidth: '64px',
      height: '32px',
      minHeight: '32px'
    } as const,
    inlineFormList: {
      display: 'flex' as const,
      flexDirection: 'column' as const,
      gap: '8px'
    } as const,
    inlineFormRow: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      flexWrap: 'wrap' as const,
      gap: '12px',
      margin: 0
    } as const,
    inlineFormLabel: {
      width: '200px',
      minWidth: '200px',
      margin: 0,
      marginBottom: 0,
      fontSize: '14px',
      lineHeight: 1.5,
      color: theme.tokens.colors.text.primary
    } as const,
    inlineFormInput: {
      width: '120px',
      minWidth: '120px',
      height: '32px',
      margin: 0,
      marginBottom: 0,
      padding: '4px 8px',
      fontSize: '14px',
      lineHeight: '20px',
      boxSizing: 'border-box' as const,
      border: '1px solid #a0a0a0',
      borderRadius: '4px'
    } as const,
    errorText: {
      margin: '8px 0 0',
      fontSize: '14px',
      lineHeight: 1.5,
      color: theme.tokens.colors.danger.primary
    } as const,
    exclusionAirlinesCard: {
      width: '100%',
      maxWidth: '720px',
      boxSizing: 'border-box' as const,
      padding: 0,
      backgroundColor: theme.tokens.colors.common.white,
      border: '1px solid #D3D7DB',
      borderRadius: '8px',
      overflow: 'hidden' as const
    } as const,
    airlineList: {
      display: 'flex' as const,
      flexDirection: 'column' as const,
      gap: 0
    } as const,
    airlineListRowFirst: {
      borderTopLeftRadius: '7px',
      borderTopRightRadius: '7px'
    } as const,
    airlineDisplayRow: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      flexWrap: 'nowrap' as const,
      gap: '16px',
      width: '100%',
      padding: '12px 20px',
      borderBottom: '1px solid #D3D7DB',
      boxSizing: 'border-box' as const
    } as const,
    airlineDisplayName: {
      flex: '1 1 auto',
      minWidth: 0,
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: 1.5,
      color: theme.tokens.colors.text.primary
    } as const,
    airlineDisplayActions: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      flexShrink: 0,
      gap: '16px',
      marginLeft: 'auto'
    } as const,
    airlineEditLinkButton: {
      fontSize: '14px',
      lineHeight: 1.5,
      color: theme.tokens.colors.brand.primary,
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      minWidth: 'unset',
      minHeight: 'unset',
      boxShadow: 'none',
      padding: 0
    } as const,
    airlineRow: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      flexWrap: 'nowrap' as const,
      gap: '12px',
      width: '100%',
      padding: '12px 20px',
      backgroundColor: theme.tokens.colors.common.white,
      borderLeft: `3px solid ${theme.tokens.colors.brand.primary}`,
      borderBottom: '1px solid #D3D7DB',
      boxSizing: 'border-box' as const
    } as const,
    airlineRowSegment: {
      flexShrink: 0
    } as const,
    airlineRowFields: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      flex: '1 1 0',
      minWidth: 0,
      gap: '8px'
    } as const,
    airlineRowRemoveButton: {
      marginLeft: 'auto'
    } as const,
    airlineAutocompleteSelect: {
      flex: '1 1 auto',
      minWidth: '200px',
      width: '100%'
    } as const,
    airlineFormFieldRoot: {
      height: '32px',
      minHeight: '32px',
      boxSizing: 'border-box' as const
    } as const,
    airlineFormFieldInput: {
      padding: '4px 8px',
      lineHeight: '20px',
      fontSize: '14px',
      height: '100%',
      boxSizing: 'border-box' as const
    } as const,
    airlineCodeInput: {
      width: '72px',
      minWidth: '72px',
      flexShrink: 0
    } as const,
    airlineNameInput: {
      flex: '1 1 auto',
      minWidth: '120px'
    } as const,
    removeAirlineButton: {
      display: 'inline-flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      flexShrink: 0,
      width: '24px',
      height: '24px',
      minWidth: 'unset',
      minHeight: 'unset',
      boxShadow: 'none',
      color: '#7d7d7d',
      border: 'none',
      padding: 0,
      backgroundColor: 'transparent',
      fontSize: '18px',
      lineHeight: 1,
      cursor: 'pointer'
    } as const,
    exclusionAirlinesAddLink: {
      display: 'block' as const,
      width: '100%',
      marginTop: 0,
      fontSize: '14px',
      lineHeight: 1.5,
      color: theme.tokens.colors.brand.primary,
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: '12px 20px',
      boxSizing: 'border-box' as const,
      textAlign: 'left' as const
    } as const,
    exclusionAirlinesUpdateWrap: {
      display: 'flex' as const,
      justifyContent: 'flex-start' as const,
      width: '100%',
      maxWidth: '720px',
      marginTop: '16px'
    } as const,
    textLinkButton: {
      display: 'inline-block' as const,
      marginTop: '4px',
      fontSize: '14px',
      lineHeight: 1.5,
      color: theme.tokens.colors.brand.primary,
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: 0
    } as const,
    textareaForm: {
      width: '100%',
      maxWidth: '720px',
      boxSizing: 'border-box' as const
    } as const,
    textareaLabel: {
      fontSize: '12px',
      fontWeight: 500,
      marginBottom: '8px',
      color: theme.tokens.colors.text.primary
    } as const
  };
}
